import { render, staticRenderFns } from "./SSelector.vue?vue&type=template&id=68b79f5c&scoped=true"
import script from "./sSelector.ts?vue&type=script&lang=ts&external"
export * from "./sSelector.ts?vue&type=script&lang=ts&external"
import style0 from "./SSelector.vue?vue&type=style&index=0&id=68b79f5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b79f5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b79f5c')) {
      api.createRecord('68b79f5c', component.options)
    } else {
      api.reload('68b79f5c', component.options)
    }
    module.hot.accept("./SSelector.vue?vue&type=template&id=68b79f5c&scoped=true", function () {
      api.rerender('68b79f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-selector/SSelector.vue"
export default component.exports